import axios from "axios";
import { ref, computed } from "vue";
import { APIS_KPI, TIMEOUTTIME } from "@/constants/apis";
import { showConsoleError } from "@/functions/errors";
import { NAME_PROJECT, TOKEN, TYPES } from "@/constants/labels";
import { VISIBLE_PAGES } from "@/constants/labels";

import store from "@/store";
import {
  ALL_LATENCY,
  EQUIPOS,
  OPERABILITY,
  PARAMETROS,
} from "@/interfaces/SmartLink/Equipos";
import { getArrayOrSingle } from "@/functions/project";
import { CONST_SENSORES } from "@/constants/graphs";
const projectName = computed(() => store.state.projectName);

export async function getAllKPICostTableData(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  const finalAPI =
    params.kpi === VISIBLE_PAGES.wiredpeers
      ? APIS_KPI.value.getcostwired
      : APIS_KPI.value.getcostwireless;

  await axios
    .get(finalAPI, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<EQUIPOS[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          const instamesh = JSON.parse(item.wireless ?? "");
          const finalItems = {
            fecha: item.fecha,
            ip: item.ip,
            name: item.name,
            costo: instamesh.cost ? instamesh.cost : 0,
          };
          finalObj.value.push(finalItems);
        });
        showGraphs.value = finalObj.value.length > 0;
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllKPITableData(params: PARAMETROS) {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllDataKPI, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData = response.data;
      const finalObj = ref<EQUIPOS[]>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        if (params.kpi === VISIBLE_PAGES.operability) {
          finalData.forEach((item: OPERABILITY) => {
            const cantTotal =
              (item.ok ?? 0) +
              (item.alarm ?? 0) +
              (item.alert ?? 0) +
              (item.down ?? 0);
            const finalItem = {
              ip: item.ip,
              name: item.name,
              tipo: item.tipo,
              ok: parseFloat((((item.ok ?? 0) / cantTotal) * 100).toFixed(2)),
              alert: parseFloat(
                (((item.alert ?? 0) / cantTotal) * 100).toFixed(2),
              ),
              alarm: parseFloat(
                (((item.alarm ?? 0) / cantTotal) * 100).toFixed(2),
              ),
              down: parseFloat(
                (((item.down ?? 0) / cantTotal) * 100).toFixed(2),
              ),
            };
            finalObj.value.push(finalItem);
          });
        }

        if (params.kpi === VISIBLE_PAGES.quality_snr) {
          finalData.forEach((item: EQUIPOS) => {
            // Convierte a JSON la variable "snr"
            // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
            // Se aumentó PER : 0, por MIMOSA en Cananea
            const allSNR = JSON.parse(item.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

            // Si es Cananea, el valor está en el index 3 del array, si es otro proyecto, será el primer valor
            const indexNumber =
              projectName.value === NAME_PROJECT.cananea ||
                projectName.value === NAME_PROJECT.demo ||
                projectName.value === NAME_PROJECT.nacozari
                ? 3
                : 0;

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            const SNRV =
              (typeof allSNR["V"]).toUpperCase() == "OBJECT" &&
                allSNR["V"] !== null
                ? allSNR["V"][indexNumber]
                : allSNR["V"];
            const SNRH =
              (typeof allSNR["H"]).toUpperCase() == "OBJECT" &&
                allSNR["H"] !== null
                ? allSNR["H"][indexNumber]
                : allSNR["H"];

            // Convierte a JSON la variable "avgpower"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx": 0}"
            const allAVG = JSON.parse(item.avgpower ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si es Cananea, Captura el valor de PER del SNR, si es otro proyecto, valida
            // si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            const AVGtx =
              projectName.value === NAME_PROJECT.cananea ||
                projectName.value === NAME_PROJECT.demo ||
                projectName.value === NAME_PROJECT.nacozari
                ? allSNR["PER"]
                : (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
                  allAVG["tx"] !== null
                  ? allAVG["tx"][0]
                  : allAVG["tx"];

            const finalItem = {
              fecha: item.fecha ?? "",
              name: item.name ?? "",
              ip: item.ip ?? "",
              snr_h: SNRH ?? 0,
              snr_v: SNRV ?? 0,
              tipo: item.tipo ?? "",
              avgpower: AVGtx ?? 0,
            };
            finalObj.value.push(finalItem);
          });
        }

        if (params.kpi === VISIBLE_PAGES.quality_lap) {
          finalData.forEach((item: EQUIPOS) => {
            // let allSNR  = {"V": [], "H": [], "PER": 0, tx: [], rx: []};
            // let allAVG  = {"V": [], "H": [], "PER": 0, tx: [], rx: []};
            /* eslint-disable */
            let allSNR: any = {};
            let allAVG: any = {};
            let RADIOrx = 0;
            let AVGtx = 0;

            if (
              projectName.value === NAME_PROJECT.cananea ||
              projectName.value === NAME_PROJECT.demo ||
              projectName.value === NAME_PROJECT.nacozari
            ) {
              // Convierte a JSON la variable "snr"
              // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
              // Se aumentó PER : 0, por MIMOSA en Cananea
              allSNR = JSON.parse(item.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

              // Como trae valores simples o en un array, primero se valida
              // Si existe y si es un objeto (un array), se captura el primer valor del array,
              // Caso contrario se coloca el valor único que tiene
              if (allSNR.H) {
                RADIOrx =
                  (typeof allSNR["H"]).toUpperCase() == "OBJECT" &&
                    allSNR["H"] !== null
                    ? allSNR["H"][1]
                    : allSNR["H"];
              }
              if (allSNR.PER) {
                AVGtx = allSNR["PER"];
              }
            } else {
              // Convierte a JSON la variable "snr"
              // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
              allSNR = JSON.parse(item.link_radio ?? `{"tx": 0, "rx":0}`);

              // Como trae valores simples o en un array, primero se valida
              // Si existe y si es un objeto (un array), se captura el primer valor del array,
              // Caso contrario se coloca el valor único que tiene
              RADIOrx =
                (typeof allSNR["rx"]).toUpperCase() == "OBJECT" &&
                  allSNR["rx"] !== null
                  ? allSNR["rx"][0]
                  : allSNR["rx"];

              // Convierte a JSON la variable "avgpower"
              // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
              allAVG = JSON.parse(item.avgpower ?? `{"tx": 0, "rx":0}`);

              // Como trae valores simples o en un array, primero se valida
              // Si existe y si es un objeto (un array), se captura el primer valor del array,
              // Caso contrario se coloca el valor único que tiene
              AVGtx =
                (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
                  allAVG["tx"] !== null
                  ? allAVG["tx"][0]
                  : allAVG["tx"];
            }

            const finalItem = {
              fecha: item.fecha ?? "",
              name: item.name ?? "",
              ip: item.ip ?? "",
              avgpower: AVGtx.toString() ?? "",
              link_radio_rx: RADIOrx ?? 0,
              tipo: item.tipo ?? "",
            };
            finalObj.value.push(finalItem);
          });
        }

        if (params.kpi === VISIBLE_PAGES.temp_inst) {
          finalData.forEach((item: EQUIPOS) => {
            // Convierte a JSON la variable "valores"
            // Si no trae valores, convierte el valor por defecto: ""
            // Extrae el valor: ".temperature@", que siempre es un array
            const temp = JSON.parse(item.valores ?? "");
            const finalItem = {
              fecha: item.fecha,
              ip: item.ip,
              name: item.name,
              temperatura: `${(temp.temperature[0] / 100).toFixed(2)} °C`,
            };
            finalObj.value.push(finalItem);
          });
        }

        if (params.kpi === VISIBLE_PAGES.latency) {
          finalObj.value = finalData;
        }

        showGraphs.value = finalObj.value.length > 0;
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllTempAndVoltageLastMinute() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllTempAndVoltageLastMinute, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any = response.data;
      const showGraphs = ref(finalData.length > 0);
      const finalObj = ref<any>([]);
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          // Convierte a JSON la variable "wireless"
          // Si no existe, el valor por default es ""
          const valores = JSON.parse(
            item.valores ?? '{"temperature" : [0], "voltage" : [0]}',
          );

          const tempvalue = (valores.temperature[0] ?? 0) / 100;
          const voltvalue = (valores.voltage[0] ?? 0) / 100;

          finalObj.value.push({
            ip: item.ip,
            temperatura: tempvalue,
            voltaje: voltvalue,
          });
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

// VERIFICAR SI SE ELIMINARA ESTO
export async function getAllCostLastMinute() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllCostLastMinute, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any = response.data;
      const showGraphs = ref(finalData.length > 0);
      const finalObj = ref<any>([]);
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          // Convierte a JSON la variable "wireless"
          // Si no existe, el valor por default es ""
          const valor = JSON.parse(item.wireless ?? '{"cost" : 0}');
          const finalCost = valor.cost;

          finalObj.value.push({
            ip: item.ip,
            costo: finalCost,
          });
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllQualityData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllQualityData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalObj = ref<any>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          let allSNR: any = {};
          let allAVG: any = {};
          let RADIOrx = 0;
          let RADIOrxV = 0;
          let RADIOrxH = 0;
          let AVGtx = 0;
          let SNRV = 0;
          let SNRH = 0;

          if (
            projectName.value === NAME_PROJECT.cananea ||
            projectName.value === NAME_PROJECT.demo ||
            projectName.value === NAME_PROJECT.nacozari
          ) {
            // Convierte a JSON la variable "snr"
            // Si no trae valores, convierte el valor por defecto: "{"V": 0, "H":0, "PER": 0}"
            // Se aumentó PER : 0, por MIMOSA en Cananea
            allSNR = JSON.parse(item.snr ?? `{"V": 0, "H": 0, "PER": 0}`);

            const indexNumber =
              projectName.value === NAME_PROJECT.cananea ||
                projectName.value === NAME_PROJECT.demo ||
                projectName.value === NAME_PROJECT.nacozari
                ? 3
                : 0;

            SNRV =
              (typeof allSNR["V"]).toUpperCase() == "OBJECT" &&
                allSNR["V"] !== null
                ? allSNR["V"][indexNumber]
                : allSNR["V"];
            SNRH =
              (typeof allSNR["H"]).toUpperCase() == "OBJECT" &&
                allSNR["H"] !== null
                ? allSNR["H"][indexNumber]
                : allSNR["H"];

            RADIOrxV = getArrayOrSingle(allSNR["V"], 1);
            RADIOrxH = getArrayOrSingle(allSNR["H"], 1);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            if (allSNR.H) {
              RADIOrx =
                (typeof allSNR["H"]).toUpperCase() == "OBJECT" &&
                  allSNR["H"] !== null
                  ? allSNR["H"][1]
                  : allSNR["H"];
            }
            if (allSNR.PER) {
              AVGtx = allSNR["PER"];
            }
          } else {
            // Convierte a JSON la variable "snr"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
            allSNR = JSON.parse(item.link_radio ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            RADIOrx =
              (typeof allSNR["rx"]).toUpperCase() == "OBJECT" &&
                allSNR["rx"] !== null
                ? allSNR["rx"][0]
                : allSNR["rx"];

            // Convierte a JSON la variable "avgpower"
            // Si no trae valores, convierte el valor por defecto: "{"tx": 0, "rx":0}"
            allAVG = JSON.parse(item.avgpower ?? `{"tx": 0, "rx":0}`);

            // Como trae valores simples o en un array, primero se valida
            // Si existe y si es un objeto (un array), se captura el primer valor del array,
            // Caso contrario se coloca el valor único que tiene
            AVGtx =
              (typeof allAVG["tx"]).toUpperCase() == "OBJECT" &&
                allAVG["tx"] !== null
                ? allAVG["tx"][0]
                : allAVG["tx"];
          }

          if (!finalObj.value[item.ip]) {
            if (item)
              finalObj.value[item.ip] = {
                ip: item.ip,
                avgpower: AVGtx.toString() ?? "",
                // radioRX: RADIOrx ?? 0,
                snr_v: SNRV ?? 0,
                snr_h: SNRH ?? 0,
                rxh: RADIOrxH ?? 0,
                rxv: RADIOrxV ?? 0,
              };
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllLatencyData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllLatency, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalObj = ref<any>([]);
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          finalObj.value.push({
            ip: item.ip,
            name: item.name,
            tipo: item.tipo,
            subtipo: item.subtipo,
            latencia: item.latencia,
            anotacion: item.anotacion,
          });
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllRajantData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllRajantData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalObj = ref<any>({});
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          // Convierte a JSON la variable "wireless"
          // Si no existe, el valor por default es ""
          const instameshWireless = JSON.parse(item.wireless ?? "");
          const instameshWired = JSON.parse(item.wired ?? "");
          let cost = 0;
          if (instameshWired.cost) {
            cost = instameshWired.cost;
          } else {
            cost = instameshWireless.cost ? instameshWireless.cost : 0;
          }

          if (!finalObj.value[item.ip]) {
            if (item)
              finalObj.value[item.ip] = {
                ip: item.ip,
                cost: cost,
              };
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}

export async function getAllSensoresData() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref();

  await axios
    .get(APIS_KPI.value.getAllSensoresData, {
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` },
    })
    .then((response) => {
      const finalData: any[] = response.data;
      const finalObj = ref<any>({});
      const showGraphs = ref(finalData.length > 0);
      if (finalData.length > 0) {
        finalData.forEach((item: any) => {
          const valores = JSON.parse(
            item.valores ?? '{"temperature" : [0], "voltage" : [0]}',
          );

          const modelo = JSON.parse(
            item.anotacion ?? '{"model": "ES1-2450RE"}',
          );

          const arrayPosition = CONST_SENSORES[modelo.model];

          const voltvalues = valores.voltage
            ? (valores.voltage[arrayPosition] ?? 0) / 100
            : 0;
          const tempvalue = valores.temperature
            ? (valores.temperature[0] ?? 0) / 100
            : 0;
          // const voltvalue = (valores.voltage[0] ?? 0) / 100;

          if (!finalObj.value[item.ip]) {
            if (item)
              finalObj.value[item.ip] = {
                ip: item.ip,
                temperatura: tempvalue,
                voltaje: voltvalues,
              };
          }
        });
      }
      statusAxios.value = {
        status: 200,
        data: finalObj.value,
        showGraphs: showGraphs.value,
      };
    })
    .catch(function (error) {
      console.log("ERROR SENSORES:", error);
      statusAxios.value = { status: 400, data: [], showGraphs: false };
      showConsoleError(error);
    });
  return statusAxios.value;
}
